import React, { useContext, useEffect, useRef, useState } from "react";
import useFetch from "../hooks/useFetch";
import { Link, useHistory } from "react-router-dom";
import { StoreContext } from "../context";
import { TabPanel, TabView } from 'primereact/tabview';
import { Breadcrumbs, Loader, Counter, ColorSelector } from "../components";
import { useRecoilState } from "recoil";
import { cartItemsJSON, variantIndex } from "../states/atoms/store";
import emptyData from "../assets/empty.jpg";
import { API_BASE_URL, Simulator } from "../constant";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import swalWithBootstrapButtons from 'sweetalert2'
import axios from "axios";
import { age, DurationCredit, Salary } from "../states/atoms/simulator";
import { favoriList } from "../states/atoms/products";

// import CondorBrand from "../assets/brands/condor.svg";
// import HisenseBrand from "../assets/brands/hisense.svg";
// import CristorBrand from "../assets/brands/cristor.svg";
// import NardiBrand from "../assets/brands/nardi.svg";
import heartFull from "../assets/icons/heart_filled.svg";
import heartEmpty from "../assets/icons/heart.svg";


import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, } from "swiper";
import 'swiper/swiper-bundle.css'

import '../assets/css/productDetails.css';
import { isMobile } from "react-device-detect";

import { useDeviceSize } from 'react-device-sizes';
import Tabs from "../components/tabs/Tabs";


export default function Product({ id }) {
    const {
        smDown, //(max-width: 767.98px)
    } = useDeviceSize();


    const { response: product, error } = useFetch(`${API_BASE_URL}api/products/getbyid/${id}`);

    const refs = useRef([]);
    const { t, i18n } = useTranslation();
    const dImages = [
        '../images/img1.jpg',
        '../images/img2.jpg',
        '../images/img3.jpg',
        '../images/img4.jpg',
        '../images/img5.jpg',
    ];
    const [img, setImg] = useState(dImages[0]);
    const [favorie, setFavorie] = useRecoilState(favoriList);


    const history = useHistory();
    const { setCart } = useContext(StoreContext);

    const [imageIndex, setImageIndex] = useState(0);
    // eslint-disable-next-line
    const [colorIndex, setColorIndex] = useRecoilState(variantIndex);
    const [selectedVariant, setSelectedVariant] = useState(0);

    const [quantity, setQuantity] = useState(1);
    const [cartItems, setCartItems] = useRecoilState(cartItemsJSON);

    //todo:simulator state "recoil"
    const [durationSimulator, setDurationSimulator] = useRecoilState(DurationCredit);
    const [ageSimulator, setAgeSimulator] = useRecoilState(age);
    const [salarySimulator, setSalarySimulator] = useRecoilState(Salary);

    const result_48 = useRef(0);
    const result_60 = useRef(0);
    const result_36 = useRef(0);
    const result_24 = useRef(0);
    const result_12 = useRef(0);

    const [price_48, setPrice_48] = useState(0);
    const [price_60, setPrice_60] = useState(0);
    const [price_36, setPrice_36] = useState(0);
    const [price_24, setPrice_24] = useState(0);
    const [price_12, setPrice_12] = useState(0);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // useEffect(()=>{priceHandler()},[]);

    useEffect(async () => {
        let res = await axios.get(`${API_BASE_URL}api/products/getbyid/${id}`)

        if (!res?.data?.variantes[colorIndex]) {

            setColorIndex(0);

        }

        if (true) {
            result_60.current = Simulator(ageSimulator, salarySimulator, res.data?.variantes[colorIndex]?.price, 60);
            result_48.current = Simulator(ageSimulator, salarySimulator, res.data?.variantes[colorIndex]?.price, 48);
            result_36.current = Simulator(ageSimulator, salarySimulator, res.data?.variantes[colorIndex]?.price, 36);
            result_24.current = Simulator(ageSimulator, salarySimulator, res.data?.variantes[colorIndex]?.price, 24);
            result_12.current = Simulator(ageSimulator, salarySimulator, res.data?.variantes[colorIndex]?.price, 12);

            setPrice_60(parseInt(result_60.current.versement[0].echp) * quantity);
            setPrice_48(parseInt(result_48.current.versement[0].echp) * quantity);
            setPrice_36(parseInt(result_36.current.versement[0].echp) * quantity);
            setPrice_24(parseInt(result_24.current.versement[0].echp) * quantity);
            setPrice_12(parseInt(result_12.current.versement[0].echp) * quantity);

        }
    }, [colorIndex, quantity]);

    const checkFavori = (refernce) => favorie.some(el => el.refernce === refernce);

    const handleAddFavori = ({ id, name, image, prix, refernce }) => {
        setFavorie([...favorie, { id, name, image, prix, refernce }]);
    };

    const handleDeleteItems = ({ refernce }) => {
        const newList = favorie.filter(element => element.refernce !== refernce);
        setFavorie(newList);
    };

    const handleAddCart = () => {
        if (i18n.language === 'fr') {
            if (colorIndex != null) {
                setCart((cart) => {
                    const itemIndex = cart.findIndex((item) => item.id === id);
                    setCartItems([...cartItems, {
                        id,
                        name,
                        description,
                        amount: quantity,
                        image: images ? API_BASE_URL + images[0].url : emptyData,
                        variantes,
                        colorIndex,
                    },]);

                    return [...cart, {
                        id,
                        name,
                        description,
                        amount: quantity,
                        image: images ? API_BASE_URL + images[0].url : emptyData,
                        variantes,
                        colorIndex,
                    },];
                });
            }
            return swalWithBootstrapButtons.fire({
                title: "Produit ajouté au panier avec succès\n",
                text: "",
                icon: 'success',
                showCancelButton: true,
                color: '',
                iconColor: '#f9bb02',
                denyButtonColor: '#1c1c1c',
                confirmButtonColor: '#003a80',
                cancelButtonColor: '#003a80',
                confirmButtonText: 'Consulter le panier',
                cancelButtonText: 'Continuer vos achats',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    return history.push('/cart');
                } else if (/* Read more about handling dismissals below */
                    result.dismiss === Swal.DismissReason.cancel) {
                    return history.push('/products');
                }
            })
        } else {
            if (colorIndex != null) {
                setCart((cart) => {
                    const itemIndex = cart.findIndex((item) => item.id === id);
                    setCartItems([...cartItems, {
                        id,
                        name,
                        description,
                        amount: quantity,
                        image: images ? API_BASE_URL + images[0].url : emptyData,
                        variantes,
                        colorIndex,
                    },]);

                    return [...cart, {
                        id,
                        name,
                        description,
                        amount: quantity,
                        image: images ? API_BASE_URL + images[0].url : emptyData,
                        variantes,
                        colorIndex,
                    },];
                });
            }

            return swalWithBootstrapButtons.fire({
                title: "تمت الإضافة بنجاح إلى عربة التسوق",
                text: "تم إضافة المنتج في السلة أين تريد أن تذهب ؟",
                icon: 'success',
                showCancelButton: true,
                color: '',
                iconColor: '#f9bb02',
                denyButtonColor: '#1c1c1c',
                confirmButtonColor: '#003a80',
                cancelButtonColor: '#003a80',
                confirmButtonText: 'السلة',
                cancelButtonText: 'المنتجات',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    return history.push('/cart');
                } else if (/* Read more about handling dismissals below */
                    result.dismiss === Swal.DismissReason.cancel) {
                    return history.push('/products');
                }
            })
        }


    };

    if (!product) return <Loader />;
    if (error) return <div>Error.</div>;

    const { name, brand, variantes, images, category, stars, description, namear, descriptionar, } = product;

    refs.current = [];
    const addRefs = (el) => {
        if (el && !refs.current.includes(el)) {
            refs.current.push(el);
        }
    };

    return (<>

        {isMobile ? (<></>) : i18n.language === "fr" ? (
            <Breadcrumbs>
                <Link to="/">{t('navbar.home')}</Link>
                <Link to="/products">{t('navbar.products')}</Link>
                <span>{name}</span>
            </Breadcrumbs>
        ) : (
            <Breadcrumbs>
                <Link to="/products">{t('navbar.products')}</Link>
                <Link to="/">{t('navbar.home')}</Link>
                <span>{name}</span>
            </Breadcrumbs>
        )}



        <section className="w-full mb-10">
            <div className="tw-container py-0 md:py-16">
                {/* TODO: FIX RESPONSIVE */}
                <div className={`w-full h-full flex flex-col gap-0 md:gap-4 lg:gap-4 ${i18n.language === 'ar' ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
                    <div className="md:w-1/2 xl:w-2/3 h-full">
                        <div className=" sm:w-full h-full block my-12">
                            <div className="h-full mb-4">
                                <img className="mx-auto h-72 md:h-96 w-auto object-cover" alt='...'
                                    src={images.length !== 0 ? (API_BASE_URL + images[imageIndex]?.url) : emptyData} />
                            </div>
                            <Swiper
                                spaceBetween={20}
                                // centeredSlides={true}
                                slidesPerView={smDown ? (images.length > 3 ? 3 : images.length) : (images.length > 5 ? 5 : images.length)}
                                // navigation
                                autoplay={{
                                    delay: 2000, disableOnInteraction: true,
                                }}
                                pagination={{
                                    clickable: true,
                                }}
                                loop={true}
                                modules={[Autoplay, Pagination]}
                                className="product-swiper"
                            >
                                {images.map((image, index) => (
                                    <SwiperSlide className="img-slide" key={index}>
                                        <div
                                            className="img_wrap"
                                            key={index}
                                            onClick={() => setImageIndex(index)}
                                            ref={addRefs}
                                        >
                                            <img className={`${imageIndex === index ? "border-2 border-primary-color" : ""}`} src={API_BASE_URL + image?.url} alt="" />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>

                    <article
                        id="product-info"
                        className="capitalize flex-col gap-5 lg:gap-4 text-sm md:text-base"
                    >
                        <div>
                            <h2 className="" style={{ lineHeight: "3rem" }}>{i18n.language === "fr" ? name : namear.length > 1 ? namear : name}</h2>
                        </div>

                        <Tabs
                            activeIndex={
                                [60, 48, 36, 24, 12].indexOf(durationSimulator) >= 0
                                    ? [60, 48, 36, 24, 12].indexOf(durationSimulator)
                                    : 0
                            }
                            onTabChange={(index) =>
                                setDurationSimulator([60, 48, 36, 24, 12][index])
                            }
                            tabs={[
                            {
                                tabTitle: t('simulator.months60'),
                                heading: `${numberWithCommas(price_60)}.00 ${t('product.currency')}`
                            },
                            {
                                tabTitle: t('simulator.months48'),
                                heading: `${numberWithCommas(price_48)}.00 ${t('product.currency')}`
                            },

                            {
                                tabTitle: t('simulator.months36'),
                                heading: `${numberWithCommas(price_36)}.00 ${t('product.currency')}`
                            },
                            {
                                tabTitle: t('simulator.months24'),
                                heading: `${numberWithCommas(price_24)}.00 ${t('product.currency')}`
                            },
                            {
                                tabTitle: t('simulator.months12'),
                                heading: `${numberWithCommas(price_12)}.00 ${t('product.currency')}`
                            },
                        ]
                        } />

                        <p className="leading-loose my-4">{i18n.language === "fr" ? description : descriptionar.length > 1 ? descriptionar : description}</p>
                        <div className=" flex flex-col gap-4">
                            <p className={`flex justify-between ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                                <span className="font-bold">{t('product.productFamille')}</span>
                                {category?.name}
                            </p>
                            <p className={`flex justify-between ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                                <span className="font-bold">{t('product.productRef')}</span>
                                {variantes[colorIndex] ? variantes[colorIndex]?.reference : variantes[0]?.reference}
                            </p>
                            <p className={`flex justify-between ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                                <span className="font-bold">{t('product.productName')}</span>
                                {variantes[colorIndex] ? variantes[colorIndex]?.name : variantes[0]?.name}
                            </p>
                        </div>
                        <hr className="my-4 md:my-6" />
                        <>
                            {/* <div id="colors" className="grid grid-cols-2 w-3/5 lg:w-2/5">
                                <span className="font-bold text-lg">{t('product.productColor')}:</span>

                                <ColorSelector
                                    colors={variantes}
                                    index={colorIndex}
                                    setIndex={setColorIndex}
                                />
                            </div> */}
                            <div id="colors" className="flex justify-between">
                                <span className="font-bold text-lg">
                                    {t("product.productColor")}:
                                </span>

                                <ColorSelector

                                    colors={variantes.map(variant => ({
                                        ...variant,
                                        color: variant.color?.toLowerCase().trim() === 'noir' ? '#000000' : variant.color?.trim().length === 6 ? `#${variant.color}` : variant.color
                                    }))}
                                    index={colorIndex}
                                    setIndex={setColorIndex}
                                />
                            </div>

                            {/* <div id="colors" className="grid grid-cols-2 w-3/5 lg:w-3/5">
                                <span className="font-bold text-lg my-auto">{t('product.productQuantity')}:</span>
                                <Counter
                                    className="ml-2 my-3 text-4xl lg:text-4xl"
                                    count={quantity}
                                    setCount={setQuantity}
                                />
                            </div> */}
                            <div id="colors" className="flex justify-between">
                                <span className="font-bold text-lg my-auto">{t('product.productQuantity')}:</span>
                                <Counter
                                    className="ml-2 my-3 text-4xl lg:text-4xl"
                                    count={quantity}
                                    setCount={setQuantity}
                                />
                            </div>
                            <div className="flex justify-between my-6">
                                <button
                                    className="btn bg-primary-color text-white font-bold px-4 hover:bg-yellow-500 transition rounded-xl"
                                    onClick={handleAddCart}
                                >
                                    {t('product.addToCard')}
                                </button>
                                <a className="hover:scale-110 transform transition-transform duration-150 cursor-pointer my-auto" onClick={() => {
                                    if (checkFavori(variantes[0]?.reference)) {
                                        handleDeleteItems({ refernce: variantes[0]?.reference });
                                    } else {
                                        handleAddFavori({
                                            id,
                                            name,
                                            name_ar: namear,
                                            image: `${API_BASE_URL}${images[0]?.url}`,
                                            prix: variantes[0]?.price,
                                            refernce: variantes[0]?.reference
                                        });
                                    }
                                }}>
                                    <img className="h-6 md:h-10 lg:h-12 hover:scale-110 transform transition-transform  duration-500" src={checkFavori(variantes[0]?.reference) ? heartFull : heartEmpty} alt="Heart" />
                                </a>
                            </div>
                        </>
                    </article>
                </div>
            </div>
        </section>
    </>)
        ;
}


// <section className="text-right">
//     <div className="tw-container py-16 ">
//         {/*<Link to="/products" className="btn-sm bg-primary-color text-white w-max">*/}
//         {/*    كل المنتوجات*/}
//         {/*</Link>*/}
//         <div className="grid lg:grid-cols-2 items-center gap-16 mt-6 border-solid">
//             <article id="product-photos" className="w-[600px] h-[600px]	ml-20">
//                 {images.length != 0 ? (<img
//                     alt={"..."}
//                     className="main-product-image-sm md:main-product-image-md lg:main-product-image bg-gray-300 rounded object-fill w-[600px] h-[600px]"
//                     src={`${API_BASE_URL + images[imageIndex].url}`}
//                 />) : (<img
//                     alt="..."
//                     className="main-product-image-sm md:main-product-image-md lg:main-product-image bg-gray-300 rounded object-fill w-full"
//                     src={emptyData}
//                 />)}

//                 <div className="mt-4 grid grid-cols-5 gap-4">
//                     {images ? (images.slice(1).map((image, i) => (<img
//                         alt={image.name}
//                         key={image.id}
//                         className={`bg-gray-300 h-[600px] md:h-20 w-[600px] object-fill rounded cursor-pointer ${imageIndex === i ? "border-2 border-blue-900" : ""}`}
//                         src={API_BASE_URL + image?.url}
//                         onClick={() => images.length <= 2 ? setImageIndex(i + 1) : setImageIndex(i)}
//                     />))) : (<img
//                         alt="..."
//                         className="main-product-image-sm md:main-product-image-md lg:main-product-image bg-gray-300 rounded object-fill w-full"
//                         src={emptyData}
//                     />)}
//                 </div>
//             </article>
//             <article
//                 id="product-info"
//                 className="capitalize flex flex-col gap-5 lg:gap-4 text-right text-sm md:text-base"
//             >
//                 <div>
//                     <h2 className="font-bold">{namear == ("" || "/") ? name : namear}</h2>
//                 </div>
//                 <TabView>
//                     <TabPanel header="6 شهر">
//                         <h4 className="font-bold text-lg lg:text-2xl text-primary-color-200">
//                             {t('product.from')} {numberWithCommas(price_48)}.00 دج
//                         </h4>
//                     </TabPanel>
//                     <TabPanel header="36 شهر">
//                         <h4 className="font-bold text-lg lg:text-2xl text-primary-color-200">
//                             {t('product.from')} {numberWithCommas(price_36)}.00 دج
//                         </h4>
//                     </TabPanel>
//                     <TabPanel header="24 شهر">
//                         <h4 className="font-bold text-lg lg:text-2xl text-primary-color-200">
//                             {t('product.from')} {numberWithCommas(price_24)}.00 دج
//                         </h4>
//                     </TabPanel>
//                     <TabPanel className="text-blueGray-400" header="12 شهر">
//                         <h4 className="font-bold text-lg lg:text-2xl text-primary-color-200">
//                             {t('product.from')} {numberWithCommas(price_12)}.00 دج
//                         </h4>
//                     </TabPanel>
//                 </TabView>

//                 <p className="leading-loose">{descriptionar == ("" || "/") ? description : descriptionar}</p>
//                 <div className="w-4/5 lg:w-3/5 flex flex-col gap-4 self-end">
//                     <p className="grid grid-cols-2 ">
//                         {category?.name}
//                         <span className="font-bold">:{t('product.productFamille')} </span>
//                     </p>
//                     <p className="grid grid-cols-2">
//                         {variantes[colorIndex] ? variantes[colorIndex].reference : variantes[0].reference}
//                         <span className="font-bold">:{t('product.productRef')} </span>
//                     </p>
//                     <p className="grid grid-cols-2">
//                         {variantes[colorIndex] ? variantes[colorIndex].name : variantes[0].name}
//                         <span className="font-bold">:{t('product.productName')}</span>
//                     </p>
//                 </div>
//                 <hr className="my-4 md:my-6" />
//                 <>
//                     <div id="colors" className="grid grid-cols-2 w-3/5 lg:w-2/5 self-end">
//                         <ColorSelector
//                             colors={variantes}
//                             index={colorIndex}
//                             setIndex={setColorIndex}
//                         />
//                         <span className="font-bold">: {t('product.productColor')} </span>
//                     </div>

//                     <span
//                         className="font-bold text-right justify-self-end">:{t('product.productQuantity')}</span>
//                     <div className="flex justify-between">

//                         <a className="hover:scale-110 transform transition-transform duration-300 cursor-pointer my-auto" onClick={() => {
//                             if (checkFavori(variantes[0]?.reference)) {
//                                 handleDeleteItems({ refernce: variantes[0]?.reference });
//                             } else {
//                                 handleAddFavori({
//                                     id,
//                                     name,
//                                     name_ar: namear,
//                                     image: `${API_BASE_URL}${images[0]?.url}`,
//                                     prix: variantes[0]?.price,
//                                     refernce: variantes[0]?.reference
//                                 });
//                             }
//                         }}>
//                             <img className="h-6 md:h-10 lg:h-12 hover:scale-110 transform transition-transform  duration-500" src={checkFavori(variantes[0]?.reference) ? heartFull : heartEmpty} alt="Heart" />
//                         </a>
//                         <Counter
//                             className="ml-2 my-3 text-4xl lg:text-4xl"
//                             count={quantity}
//                             setCount={setQuantity}
//                         />
//                     </div>
//                     <button
//                         className="btn bg-primary-color text-white self-end md:w-1/2 lg:w-max transition hover:bg-secondary-color font-bold rounded-xl"
//                         onClick={handleAddCart}
//                     >
//                         {t('product.addToCard')}
//                     </button>
//                 </>
//             </article>
//         </div>
//     </div>
// </section>